import { Document } from "@/shared/domains";
import { parseResponseData, privateAPI } from "@/shared/lib";

const DOMAIN = "labs";

export const getLabRequisitionFormsQuery = () => ({
  queryKey: [DOMAIN, "getLabRequisitionFormsQuery"],
  queryFn: async () => {
    const response = await privateAPI.get(`/labs/requisition-forms`);

    return parseResponseData(response, Document.array());
  },
});
